import { useTranslation } from "react-i18next";
import imgCheck from "../../assets/images/icons/circle-check.svg";

function SectionPackage() {
  const { t } = useTranslation();

  const packages = [
    {
      title: t('landing.package.critical.title'),
      subtitle: t('landing.package.critical.subtitle'),
      color: "bg-[#DE4F44]", // merah
      items: [
        t('landing.package.critical.item1'),
        t('landing.package.critical.item2'),
        t('landing.package.critical.item3'),
        t('landing.package.critical.item4'),
        t('landing.package.critical.item5'),
        t('landing.package.critical.item6'),
        t('landing.package.critical.item7'),
      ],
      header: t('landing.package.critical.header'),
      footer: t('landing.package.critical.footer'),
    },

    {
      title: t('landing.package.highPriority.title'),
      subtitle: t('landing.package.highPriority.subtitle'),
      color: "bg-[#0369A1]", // biru
      items: [
        t('landing.package.highPriority.item1'),
        t('landing.package.highPriority.item2'),
        t('landing.package.highPriority.item3'),
        t('landing.package.highPriority.item4'),
        t('landing.package.highPriority.item5'),
        t('landing.package.highPriority.item6'),
        t('landing.package.highPriority.item7'),
      ],
      header: t('landing.package.highPriority.header'),
      footer: t('landing.package.highPriority.footer'),
    },

    {
      title: t('landing.package.scheduled.title'),
      subtitle: t('landing.package.scheduled.subtitle'),
      color: "bg-[#0B622A]", // hijau
      items: [
        t('landing.package.scheduled.item1'),
        t('landing.package.scheduled.item2'),
        t('landing.package.scheduled.item3'),
        t('landing.package.scheduled.item4'),
        t('landing.package.scheduled.item5'),
        t('landing.package.scheduled.item6'),
        t('landing.package.scheduled.item7'),
      ],
      header: t('landing.package.scheduled.header'),
      footer: t('landing.package.scheduled.footer'),
    },
  ];

  return (
    <section id="packages" className="bg-white">
      <div className="py-10 px-6 md:py-24 md:px-24">
        <h1 className="text-[38px] md:text-[46px] font-[CormorantGaramond] font-bold text-center">
          {t('landing.package.title')}
        </h1>
        <p className="text-sm mt-3 text-center">
          {t('landing.package.subtitle')}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 mt-8 gap-8 max-w-7xl mx-auto">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl shadow-md border border-gray-200 overflow-hidden"
            >
              {/* Header */}
              <div className={`${pkg.color} text-white text-center pt-9 pb-6`}>
                <h3 className="text-2xl font-[CormorantGaramond] font-bold mb-1">
                  {pkg.title}
                </h3>
                <p className="text-sm font-bold opacity-90">{pkg.subtitle}</p>
              </div>

              {/* Body */}
              <div className={pkg.color}>
                <div className="p-5 bg-white rounded-t-3xl">
                  <div className="font-bold text-center mb-5 text-[#12100EB2]">
                    {pkg.header}
                  </div>
                  <ul className="space-y-4">
                    {pkg.items.map((item, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <img src={imgCheck} alt="imgCheck" loading="lazy" decoding="async" className="w-5 h-5 mt-0.5" />
                        <span className="text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Footer */}
                  <p className="text-gray-600 mt-6 text-sm text-center leading-relaxed">
                    {pkg.footer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SectionPackage;
